import { CardBody } from '@chakra-ui/react';

import type { ScreenerTableData } from '../../DataProvider/ScreenerTableMultiMetricProvider';
import { ChartCard, type ChartProps } from '../ChartRoot/Chart';
import { ScreenerTable } from './ScreenerTable';

type ScreenerTableChartContentProps = Pick<ChartProps, 'onClick'> & {
  data?: ScreenerTableData;
};

export const ScreenerTableChartContent = ({
  data,
  onClick,
}: ScreenerTableChartContentProps) => {
  if (!data) {
    return null;
  }

  return (
    <ChartCard
      onClick={onClick}
      position="relative"
      display="flex"
      flexDirection="column"
      minHeight="0"
      height="100%"
    >
      <CardBody
        data-testid="card-body"
        padding="14px 14px 0.5rem"
        flex="1"
        minHeight="0"
        display="flex"
        flexDirection="column"
        overflow="hidden"
      >
        <ScreenerTable data={data} />
      </CardBody>
    </ChartCard>
  );
};
